import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Bookmark(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.183 3C6.53 3 6 3.531 6 4.183v16.338l4.765-2.637a2.583 2.583 0 012.5-.004l4.765 2.62V4.183c0-.652-.531-1.183-1.183-1.183H7.183zM5.428 22.921c-.25 0-.498-.066-.724-.2A1.413 1.413 0 014 21.491V4.183A3.187 3.187 0 017.183 1h9.664a3.187 3.187 0 013.183 3.183v17.283c0 .51-.262.97-.701 1.23-.44.26-.967.268-1.416.022l-5.61-3.085a.59.59 0 00-.57.001L6.122 22.74a1.426 1.426 0 01-.693.181z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoBookmark = React.memo(Bookmark);
export default MemoBookmark;